// extracted by mini-css-extract-plugin
export var indeterminate = "_5d-5";
export var md = "_5d-4";
export var semantic = "_5d-6";
export var sm = "_5d-3";
export var text = "_5d-7";
export var toggleInput = "_5d-0";
export var toggleSwitch = "_5d-1";
export var xs = "_5d-2";